import { CustomRulesRuleOutcomeWebComponent } from './component/CustomRulesRuleOutcomeWebComponent';
import { DetectionRuleType } from "../customRulesGrid/types";

export { CustomRulesRuleOutcomeWebComponent };

export const RULE_FIELDS_NAME_MAPPING = {
  [DetectionRuleType.PROCESS]: {
    'Name': 'Name',
    'Path': 'Path',
    'FullPathName': 'Full Path Name',
    'CommandLine': 'Command Line',
    'Parent.Name': 'Parent Name',
    'Parent.Path': 'Parent Path',
    'Parent.FullPathName': 'Parent Full Path Name',
    'Parent.CommandLine': 'Parent Command Line',
    'User': 'User',
    'MD5': 'MD5',
    'SHA2': 'SHA256',
  },
  [DetectionRuleType.FILE]: {
    'Name': 'Name',
    'Path': 'Path',
    'FullPathName': 'Full Path Name',
    'CreatedBy.Name': 'Creation Process Name',
    'CreatedBy.Path': 'Creation Process Path',
    'CreatedBy.FullPathName': 'Creation Process Full Path Name',
    'CreatedBy.CommandLine': 'Creation Process Command Line',
    'Operation': 'Operation',
    'MD5': 'MD5',
    'SHA2': 'SHA256',
    'Url': 'URL',
  },
  [DetectionRuleType.CONNECTION]: {
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourcePort': 'Source Port',
    'DestinationPort': 'Destination Port',
    'SourceUser': 'Source user',
    'DestinationUser': 'Destination user',
    'Process.Name': 'Creation Process Name',
    'Process.Path': 'Creation Process Path',
    'Process.FullPathName': 'Creation Process Full Path Name',
    'Process.CommandLine': 'Creation Process Command Line',
    'Process.User': 'Creation Process User',
    'Protocol': 'Protocol',
    'URL': 'URL',
    'HTTPUser': 'HTTP User',
    'HTTPDownloadedFile': 'HTTP Downloaded File',
    'HTTPUploadedFile': 'HTTP Uploaded File',
    'FTPUser': 'FTP User',
    'SMBDomain': 'SMB Domain',
    'SMBSharePath' :'SMB Share Path',
    'SMBUser': 'SMB User',
    'SSHUser': 'SSH User',
    'WMIExecQuery': 'WMI Exec Query',
    'TelnetUser': 'Telnet User',
    'FileRemoteOperation': 'File Remote Operation',
    'FileRemotePath': 'File Remote Path',
    'File.Name': 'File Name',
    'Email.Subject': 'Email Subject',
    'Application.Name': 'Application Name',
    'KeyVault.Name': 'Key Vault Name',
    'Role.Name': 'Role Name',
    'Policy.Name': 'Policy Name',
    'SharingLink.Name': 'Sharing Link Name',
    'Flow.Name': 'Flow Name',
    'Url.Name': 'URL Name',
    'SshKey.Name': 'SSH Key Name',
    'LaunchTemplate.Name': 'Launch Template Name',
    'ServicePrincipal.Name': 'Service Principal Name',
    'UserGroup.Name': 'User Group Name',
    'AutomationAccount.Name': 'Automation Account Name',
    'AutomationAccountHook.Name': 'Automation Account Hook Name',
    'Api.Name': 'Api Name',
    'CertificateAuthority.Name': 'Certificate Authority Name',
    'Bucket.Name': 'Bucket Name',
    'BitbucketRepository.Name': 'Bitbucket Repository Name',
    'JiraProject.Name': 'Jira Project Name',
    'ConfluencePage.Name': 'Confluence Page Name',
  },
  [DetectionRuleType.REGISTRY]: {
    'Key': 'Key',
    'Value': 'Value',
    'Operation': 'Operation',
    'CreatedBy.Name': 'Creation Process Name',
    'CreatedBy.Path': 'Creation Process Path',
    'CreatedBy.FullPathName': 'Creation Process Full Path Name',
    'CreatedBy.CommandLine': 'Creation Process Command Line',
  },
  [DetectionRuleType.USER_LOGIN]: {
    'Name': 'Name',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
    'Domain': 'Domain',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'File.Name': 'File Name',
    'Email.Subject': 'Email Subject',
    'Application.Name': 'Application Name',
    'KeyVault.Name': 'Key Vault Name',
    'Role.Name': 'Role Name',
    'Policy.Name': 'Policy Name',
    'SharingLink.Name': 'Sharing Link Name',
    'Flow.Name': 'Flow Name',
    'Url.Name': 'URL Name',
    'SshKey.Name': 'SSH Key Name',
    'LaunchTemplate.Name': 'Launch Template Name',
    'ServicePrincipal.Name': 'Service Principal Name',
    'UserGroup.Name': 'User Group Name',
    'AutomationAccount.Name': 'Automation Account Name',
    'AutomationAccountHook.Name': 'Automation Account Hook Name',
    'Api.Name': 'Api Name',
    'CertificateAuthority.Name': 'Certificate Authority Name',
    'Bucket.Name': 'Bucket Name',
    'BitbucketRepository.Name': 'Bitbucket Repository Name',
    'JiraProject.Name': 'Jira Project Name',
    'ConfluencePage.Name': 'Confluence Page Name',
  },
  [DetectionRuleType.EMAIL]: {
    'Subject': 'Subject',
    'Sender': 'Sender',
    'Receivers': 'Receiver',
    'Attachments': 'Attachment',
    'Url': 'URL',
  },
  [DetectionRuleType.APPLICATION]: {
    'Name': 'Name',
    'Id': 'Id',
    'Address': 'Application Address',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.KEY_VAULT]: {
    'Name': 'Name',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.ROLE]: {
    'Name': 'Name',
    'Id': 'Id',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.POLICY]: {
    'Name': 'Name',
    'Id': 'Id',
    'ResourcePolicyType': 'Resource Policy Type',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.SHARING_LINK]: {
    'Name': 'Name',
    'Url': 'URL',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.FLOW]: {
    'Name': 'Name',
    'Id': 'Id',
    'Url': 'URL',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.URL]: {
    'Name': 'Name',
    'Url': 'URL',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.SSH_KEY]: {
    'Name': 'Name',
    'PublicKey': 'SSH Public Key',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.LAUNCH_TEMPLATE]: {
    'Name': 'Name',
    'Id': 'Id',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.SERVICE_PRINCIPAL]: {
    'Name': 'Name',
    'Id': 'Id',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.USER_GROUP]: {
    'Name': 'Name',
    'Id': 'Id',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.AUTOMATION_ACCOUNT]: {
    'Name': 'Name',
    'Id': 'Id',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.AUTOMATION_ACCOUNT_HOOK]: {
    'Name': 'Name',
    'Id': 'Id',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.API]: {
    'Name': 'Name',
    'Id': 'Id',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.CERTIFICATE_AUTHORITY]: {
    'Name': 'Name',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.BUCKET]: {
    'Name': 'Name',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.BITBUCKET_REPOSITORY]: {
    'Name': 'Name',
    'Id': 'Id',
    'Url': 'URL',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
  },
  [DetectionRuleType.JIRA_PROJECT]: {
    'Name': 'Name',
    'Id': 'Id',
    'Domain': 'Domain',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
  },
  [DetectionRuleType.CONFLUENCE_PAGE]: {
    'Name': 'Name',
    'Id': 'Id',
    'Url': 'URL',
    'SourceUser': 'Source User',
    'DestinationUser': 'Destination User',
    'SourceIP': 'Source IP',
    'DestinationIP': 'Destination IP',
  }
};

export const RULE_RELATIONS_MAPPING = {
  is: 'is',
  contains: 'contains',
  any: 'is one of',
};

export const RULE_OUTCOME_CONFIG = {
  [DetectionRuleType.PROCESS]: {
    prefix: 'Process',
  },
  [DetectionRuleType.FILE]: {
    prefix: 'File',
  },
  [DetectionRuleType.CONNECTION]: {
    prefix: 'Connection',
  },
  [DetectionRuleType.REGISTRY]: {
    prefix: 'Registry',
  },
  [DetectionRuleType.USER_LOGIN]: {
    prefix: 'UserLogin',
  },
  [DetectionRuleType.EMAIL]: {
    prefix: 'Email',
  },
  [DetectionRuleType.APPLICATION]: {
    prefix: 'Application',
  },
  [DetectionRuleType.KEY_VAULT]: {
    prefix: 'KeyVault',
  },
  [DetectionRuleType.ROLE]: {
    prefix: 'Role',
  },
  [DetectionRuleType.POLICY]: {
    prefix: 'Policy',
  },
  [DetectionRuleType.SHARING_LINK]: {
    prefix: 'SharingLink',
  },
  [DetectionRuleType.FLOW]: {
    prefix: 'Flow',
  },
  [DetectionRuleType.URL]: {
    prefix: 'Url',
  },
  [DetectionRuleType.SSH_KEY]: {
    prefix: 'SshKey',
  },
  [DetectionRuleType.LAUNCH_TEMPLATE]: {
    prefix: 'LaunchTemplate',
  },
  [DetectionRuleType.SERVICE_PRINCIPAL]: {
    prefix: 'ServicePrincipal',
  },
  [DetectionRuleType.USER_GROUP]: {
    prefix: 'UserGroup',
  },
  [DetectionRuleType.AUTOMATION_ACCOUNT]: {
    prefix: 'AutomationAccount'
  },
  [DetectionRuleType.AUTOMATION_ACCOUNT_HOOK]: {
    prefix: 'AutomationAccountHook',
  },
  [DetectionRuleType.API]: {
    prefix: 'Api',
  },
  [DetectionRuleType.CERTIFICATE_AUTHORITY]: {
    prefix: 'CertificateAuthority',
  },
  [DetectionRuleType.BUCKET]: {
    prefix: 'Bucket',
  },
  [DetectionRuleType.BITBUCKET_REPOSITORY]: {
    prefix: 'BitbucketRepository',
  },
  [DetectionRuleType.JIRA_PROJECT]: {
    prefix: 'JiraProject',
  },
  [DetectionRuleType.CONFLUENCE_PAGE]: {
    prefix: 'ConfluencePage',
  }
};
